import { queryOptions } from '@tanstack/react-query';
import { APIResponse, CustomerResponse } from './types';
import { identityApi } from '../../services/identity.api';

// API Call
const fetchCustomerData = async () => {
  const endpoint = '/v1/app/customer';
  try {
    const { data } = await identityApi.get<APIResponse<CustomerResponse>>(endpoint);

    if (!data || !data.data) {
      return { ...(data?.data || {}), experience: 'offer' } as CustomerResponse;
    }

    return data.data;
  } catch (error: any) {
    if (error?.response?.status === 404 && error?.response?.data?.error_slug !== 'customer_not_found') {
      return { experience: 'offer' } as CustomerResponse;
    }
    throw error;
  }
};

// Query Factory
export const customerQueries = {
  all: () =>
    queryOptions({
      queryKey: [{ scope: 'customer' }] as const,
      queryFn: fetchCustomerData,
    }),
};
